import React, { Component } from 'react';
import {
  Row, Col, Card, CardBody, Label, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import lodash from 'lodash'; // library added for debounce functionality
import Moment from 'react-moment';
import ActivityReportService from '../../services/ActivityReportService';
import swal from 'sweetalert';
import { Roles } from '../../constants/constant.role';


class ActivityReportDataTableFM extends Component {
  state = {
    controls: {
      search: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null
      },
      activity_type: {
        value: 1,
        valid: null,
        touched: false,
        nullValue: null
      },
      from_date: {
        value: null,
        valid: null,
        touched: false,
        nullValue: null
      },
      till_date: {
        value: null,
        valid: null,
        touched: false,
        nullValue: null
      }
    },
    page: 1,
    activityTypes: []
  }

  constructor(props) {
    super(props);
    this.searchFleetFm = lodash.debounce(this.searchFleetFm, 500);
  }

  componentDidMount() {
    this.getActivityList();
  }

  resetFilter = () => {
    let { controls, page } = this.state;
    controls.activity_type.value = 1;
    controls.from_date.value = null;
    controls.till_date.value = null;
    page = 1;
    this.setState({
      controls,
      page
    });
    this.searchFleetFm(false);
  }

  getActivityList = (e) => {
    ActivityReportService.getActivityList()
      .then(response => {
        this.setState({
          activityTypes: response.data.data
        });
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          swal('', e.response.data.error[0].message, 'error');
        }
      });
  }


  deleteActivity = (id) => {
    swal({
      title: "Delete Activity",
      text: "Are you sure, you want to delete activity ?",
      icon: "warning",
      buttons: ["No", "Yes"]
    }).then(isConfirm => {
      if (isConfirm) {
        this.deleteActivityConfirm(id);
      }
    });
  }

  deleteActivityConfirm = (id) => {
    let reqData = {
      "id": id
    }
    this.props.isLoadingData(true);
    ActivityReportService.deleteActivity(reqData)
      .then(res => {
        this.props.isLoadingData(false);
        if (res.data.message) {
          swal({
            title: "",
            text: res.data.message,
            icon: "success",
            type: "success"
          }).then(value => { });
          this.searchFleetFm(false);
        }
      })
      .catch(e => {
        this.props.isLoadingData(false);
        if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
          swal('', e.response.data.error[0].message, 'error');
        }
      });
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    this.setState({ controls });
    this.searchFleetFm();
    // this.handleValidation();
  }
  handlePageClick = async (page) => {
    await this.setState({
      page: page.selected + 1
    })
    this.searchFleetFm(false, page.selected + 1);
  }

  searchFleetFm = (downloadReport = false, page = 1) => {
    const { controls } = this.state;
    let reqData = {
      page: page > 1 ? page : 1,
      activity_type: controls.activity_type.value,
      download_report: downloadReport,
      pagesize: 10
    }
    if (controls.from_date.value) {
      let date = new Date(controls.from_date.value);
      date.setHours(0);
      date.setMinutes(0);
      reqData.from_date = date;
    }
    if (controls.till_date.value) {
      let date = new Date(controls.till_date.value);
      date.setHours(23);
      date.setMinutes(59);
      reqData.to_date = date;
    }
    this.props.searchFleetSalesFm(reqData);
  }

  setEditData = (obj) => {
    this.props.setEditData(obj);
  }

  openActivityDetail = (obj) => {
    this.props.openActivityDetail(obj);
  }

  render() {
    const { controls } = this.state;
    // const { search } = controls;
    return (
      <div>
        <Row>
          <Col xl="9" md="12" xs="12">
            <Row>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="gst">Type of Activity<span className="required-field">*</span></Label>
                  <select className="form-control" name="activity_type" value={controls.activity_type.value}
                    onChange={(e) => this.handleInputChange(e)}>
                    <option value="" selected="true" disabled>Select Activity</option>
                    {
                      this.state.activityTypes && this.state.activityTypes.map((activity) => (
                        <option key={activity.id} value={activity.id}>{activity.name}</option>
                      ))
                    }
                  </select>
                  {controls.activity_type.showErrorMsg && < div className="error">* Please select type of activity</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="gst">Activities done from<span className="required-field">*</span></Label>
                  <Label onClick={e => this.from_date.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        onChange={(e) => this.handleInputChange({ target: { name: 'from_date', value: e } })}
                        selected={controls.from_date.value}
                        showMonthDropdown
                        ref={r => this.from_date = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={controls.till_date.value ? controls.till_date.value : new Date()}
                        dropdownMode="select"
                        style={{ zIndex: 'auto' }}
                        dateFormat="dd/MM/yyyy"
                        popperPlacement="bottom"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                </FormGroup>

              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="gst">Activities done till<span className="required-field">*</span></Label>
                  <Label onClick={e => this.till_date.state.open && e.preventDefault()} style={{ width: '100%' }}>
                    <InputGroup className="social-detail-date">
                      <DatePicker className="form-control"
                        onChange={(e) => this.handleInputChange({ target: { name: 'till_date', value: e } })}
                        selected={controls.till_date.value}
                        showMonthDropdown
                        ref={r => this.till_date = r}
                        placeholderText="Select Date"
                        // shouldCloseOnSelect={true}
                        showYearDropdown
                        shouldCloseOnSelect
                        maxDate={new Date()}
                        minDate={controls.from_date.value ? controls.from_date.value : null}
                        dropdownMode="select"
                        style={{ zIndex: 'auto' }}
                        dateFormat="dd/MM/yyyy"
                        popperPlacement="bottom"
                      // onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                      />
                      <InputGroupAddon addonType="append" >
                        <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                          <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                        </div>
                      </InputGroupAddon>
                    </InputGroup>
                  </Label>
                </FormGroup>

              </Col>
              <Col xl="3" md="12" xs="12" className="d-flex" onClick={() => this.resetFilter()}>
                <div className="d-flex mt-auto mb-auto cursor-pointer">
                  <img src="images/reset.svg" alt='reset' /> &nbsp;&nbsp;
                  <span>Reset</span>
                </div>
              </Col>
            </Row>
          </Col>
          {this.props.fleetReportFM && this.props.fleetReportFM.elements && this.props.fleetReportFM.elements.length > 0 && <Col xl="3" md="12" xs="12" className="d-flex cursor-pointer" style={{ justifyContent: 'flex-end', margin: 'auto' }}>
            <img src="images/download.svg" alt='download' className="download-report-icon margin-left-10" onClick={(e) => this.searchFleetFm(true)} />&nbsp;&nbsp;
            <span className="Download-Full-Report pull-right" onClick={(e) => this.searchFleetFm(true)} style={{ cursor: 'pointer' }}>Download Full Report</span>
          </Col>}
        </Row>
        <Card>
          <CardBody>
            <table className="table table-bordered table-responsive">
              <thead style={{ background: '#f6f6f6' }}>
                {
                  (controls.activity_type.value === '1' || controls.activity_type.value === 1) && <tr>
                    <th className="sales-report-th width-125-px">Activity</th>
                    <th className="sales-report-th width-110-px">Member Code</th>
                    <th className="sales-report-th width-100-px">Activity Date</th>
                    <th className="sales-report-th width-100-px">Created On</th>
                    <th className="sales-report-th">No. of Vehciles</th>
                    <th className="sales-report-th">No. Of Wheels</th>
                    <th className="sales-report-th">Avg. Inflation Pressure Noted</th>
                    <th className="sales-report-th">Alignment Practices</th>
                    <th className="sales-report-th">Rotation Practices</th>
                    <th className="sales-report-th">Action</th>
                  </tr>
                }
                {
                  (controls.activity_type.value === '2' || controls.activity_type.value === 2 || controls.activity_type.value === '4' || controls.activity_type.value === 4) && <tr>
                    <th className="sales-report-th">Activity</th>
                    <th className="sales-report-th">Member Code</th>
                    <th className="sales-report-th">Activity Date</th>
                    <th className="sales-report-th">Created On</th>
                    <th className="sales-report-th">No. of Participants</th>
                    <th className="sales-report-th">Action</th>
                  </tr>
                }
                {
                  (controls.activity_type.value === '3' || controls.activity_type.value === 3) && <tr>
                    <th className="sales-report-th">Activity</th>
                    <th className="sales-report-th">Member Code</th>
                    <th className="sales-report-th">Activity Date</th>
                    <th className="sales-report-th">Created On</th>
                    <th className="sales-report-th">No. of Tyres</th>
                    <th className="sales-report-th">Action</th>
                  </tr>
                }
              </thead>
              <tbody>
                {
                  (controls.activity_type.value === '1' || controls.activity_type.value === 1) && (this.props.fleetReportFM.elements || []).map((sale) => (
                    <tr>
                      <td className="capital-case sales-report-td cursor-pointer" onClick={() => this.openActivityDetail(sale)} style={{ color: '#545cd8', cursor: 'pointer' }}>
                        <span className="cursor-pointer">{sale.activity_name}</span></td>
                      <td className="sales-report-td" onClick={(e) => this.props.goToMemberSalesReport(sale)}>
                        {sale.member_id}
                      </td>
                      <td className="sales-report-td">
                        <Moment format="MMM DD YYYY">
                          {sale.activity_date}
                        </Moment></td>
                      <td className="sales-report-td">
                        <Moment format="MMM DD YYYY">
                          {sale.created_at}
                        </Moment></td>
                      <td className="sales-report-td">
                        {sale.number_of_vehicles_inspected}
                      </td>
                      <td className="sales-report-td">
                        {sale.number_of_wheels_inspected}
                      </td>
                      <td className="sales-report-td">
                        {sale.average_inflation_pressure_noted}
                      </td>
                      <td className="sales-report-td text-capitalize">
                        {sale.select_alignment_practices}
                      </td>
                      <td className="sales-report-td text-capitalize">
                        {sale.select_rotation_practices}
                      </td>
                      <td className="sales-report-td d-flex">
                        {
                          this.props.userDetail.type === Roles.FLEET_MANAGER_ROLE &&
                          <>
                            <img className="cursor-pointer edit-delete-icon" src="images/edit.svg" onClick={() => this.setEditData(sale)} alt='edit' /> &nbsp; &nbsp;</>
                        }
                        <img className="cursor-pointer edit-delete-icon" src="images/delete.svg" onClick={() => this.deleteActivity(sale.uuid)} alt='delete' />
                      </td>

                    </tr>
                  ))
                }
                {
                  (controls.activity_type.value === '2' || controls.activity_type.value === 2 || controls.activity_type.value === '4' || controls.activity_type.value === 4) && (this.props.fleetReportFM.elements || []).map((sale) => (
                    <tr key={sale.uuid}>
                      <td className="capital-case sales-report-td cursor-pointer" style={{ color: '#545cd8', cursor: 'pointer' }}
                        onClick={() => this.openActivityDetail(sale)}><span className="cursor-pointer">{sale.activity_name}</span></td>
                      <td className="sales-report-td">
                        {sale.member_id}
                      </td>
                      <td className="sales-report-td">
                        <Moment format="MMM DD YYYY">
                          {sale.activity_date}
                        </Moment></td>
                      <td className="sales-report-td">
                        <Moment format="MMM DD YYYY">
                          {sale.created_at}
                        </Moment></td>
                      <td className="sales-report-td">{sale.number_of_driver_attended}</td>
                      <td className="sales-report-td d-flex">
                        {
                          this.props.userDetail.type === Roles.FLEET_MANAGER_ROLE && <>
                            <img className="cursor-pointer edit-delete-icon" src="images/edit.svg" onClick={() => this.setEditData(sale)} alt='edit' /> &nbsp; &nbsp;</>
                        }
                        <img className="cursor-pointer edit-delete-icon" src="images/delete.svg" onClick={() => this.deleteActivity(sale.uuid)} alt='delete' />
                      </td>
                    </tr>
                  ))
                }
                {
                  (controls.activity_type.value === '3' || controls.activity_type.value === 3) && (this.props.fleetReportFM.elements || []).map((sale) => (
                    <tr key={sale.uuid}>
                      <td className="capital-case sales-report-td cursor-pointer" style={{ color: '#545cd8', cursor: 'pointer' }}
                        onClick={() => this.openActivityDetail(sale)}><span className="cursor-pointer">{sale.activity_name}</span></td>
                      <td className="sales-report-td">
                        {sale.member_id}
                      </td>
                      <td className="sales-report-td">
                        <Moment format="MMM DD YYYY">
                          {sale.activity_date}
                        </Moment></td>
                      <td className="sales-report-td">
                        <Moment format="MMM DD YYYY">
                          {sale.created_at}
                        </Moment></td>
                      <td className="sales-report-td">{sale.number_of_tyres_inspected}</td>
                      <td className="sales-report-td d-flex">
                        {
                          this.props.userDetail.type === Roles.FLEET_MANAGER_ROLE && <>
                            <img className="cursor-pointer edit-delete-icon" src="images/edit.svg" onClick={() => this.setEditData(sale)} alt='edit' /> &nbsp; &nbsp;</>
                        }
                        <img className="cursor-pointer edit-delete-icon" src="images/delete.svg" onClick={() => this.deleteActivity(sale.uuid)} alt='delete' />
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>

            {
              this.props.fleetReportFM.total_count <= 0 && <div className="no-data tbl-offtake-summary" style={{ maxWidth: '100%', marginTop: '-20px' }}>
                Currently, there is no data to display
              </div>
            }

            {this.props.fleetReportFM.total_count > 10 && <div className="pull-right" style={{ display: 'flex', marginTop: '10px' }}>
              <span style={{ marginTop: '7px' }}>
                <span className="showing">Showing </span>
                <span className="showing-page">
                  {`${this.props.fleetReportFM.page - 1}1`}
                  -{(((this.props.fleetReportFM.page - 1) * 10) + (this.props.fleetReportFM.elements || []).length) < 10 ? '0' : ''}{(((this.props.fleetReportFM.page - 1) * 10) + (this.props.fleetReportFM.elements || []).length)}
                  &nbsp;of {this.props.fleetReportFM.total_count < 10 ? '0' : ''}{this.props.fleetReportFM.total_count}
                </span>
              </span>
              &nbsp;&nbsp;&nbsp;

              <ReactPaginate
                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                breakLabel="..."
                breakClassName="break-me"
                pageCount={this.props.fleetReportFM.pageCount}
                // pageCount={18}
                marginPagesDisplayed={3}
                pageRangeDisplayed={2}
                onPageChange={(page) => this.handlePageClick(page)}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                pageLinkClassName="c-page"
                previousLinkClassName="c-prev"
                nextLinkClassName="c-next"
                breakLinkClassName="c-break-line"
                activeClassName="active"
                activeLinkClassName="c-page-link"
              />
            </div>}

          </CardBody>
        </Card>
      </div >
    );
  }
}

export default ActivityReportDataTableFM;